import * as React from 'react'
import * as SWR from 'hooks/swr'
import * as firebaseSdk from 'sdk/firebase'
import * as LocalStorageUtils from 'utils/local-storage'

import { useRouter } from 'next/router'

import { useAppConfig } from 'hooks/features/use-features'
import PlanNameBox from 'components/shared/plan-name-box'
import { allPages } from './all-pages'
import NavigationList from './navigation-list'
import WorkspaceButton from 'components/shared/workspace-button'

import { AuthContext } from 'providers/auth-provider'

import Button from 'components/shared/button'

const MainSidebarContent = ({}) => {
    const { removeUser } = React.useContext(AuthContext)
    const { data: planData } = SWR.useCreditsAvailable()
    const { data: appData } = SWR.useAppData()

    const router = useRouter()
    const [pageSel, setPageSel] = React.useState<number>()

    const planName = planData?.plan.name

    const { appConfig } = useAppConfig()

    const hasPlansFeature = appConfig.feature.includes('plans')

    const enabledPages = React.useMemo(
        () =>
            Object.entries(allPages)
                .filter(([pageName]) => appConfig.feature.includes(pageName) || pageName === 'settings')
                .map(([, page]) => page),
        [appConfig.feature],
    )

    const logoutUser = async () => {
        await firebaseSdk.logout()
        LocalStorageUtils.clearStorage()
        removeUser()
    }

    const actualMacrosection = React.useMemo(() => {
        const path = router.pathname.split('/')
        if (typeof pageSel !== 'undefined') return enabledPages[pageSel].path
        return path[1]
    }, [router.pathname, pageSel, enabledPages])

    return (
        <div className="p-6 h-full flex flex-1 flex-col justify-between">
            <div className="flex-1">
                <NavigationList
                    pageSel={pageSel}
                    pages={enabledPages}
                    setPageSel={setPageSel}
                    actualMacrosection={actualMacrosection}
                />
                {!appData?.single_workspace ? (
                    <div className="block mt-10 sm:hidden">
                        <WorkspaceButton />
                    </div>
                ) : null}
            </div>
            <div className="flex flex-col ">
                <Button className="display-none md:flex" variant="ghost" onClick={logoutUser}>
                    Logout
                </Button>
                {planName && hasPlansFeature ? <PlanNameBox planName={planName} /> : null}
            </div>
        </div>
    )
}

export default MainSidebarContent
